export const RESPONSIVE_PADDING = {
  xs: 3,
  sm: 6,
  lg: 12,
  xl: 16,
  xxl: 16,
};
